import { render } from "./SearchDocumentationComponent.vue?vue&type=template&id=24664230&scoped=true"
import script from "./SearchDocumentationComponent.vue?vue&type=script&lang=js"
export * from "./SearchDocumentationComponent.vue?vue&type=script&lang=js"

import "./SearchDocumentationComponent.vue?vue&type=style&index=0&id=24664230&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24664230"]])

export default __exports__